import { getProductVariantImage } from "./productCore";
import { getBrandId, getBrandLogo } from "./brandCore";

export function getOrderId(order) {
    return order?.id;
}

export function getShopOrderCreatedAt(order) {
    return order?.shopOrderCreatedAt;
}

export function getReturnId({ returnObject, orderReturn, orderItem }) {
    return orderItem?.orderReturn?.id || returnObject?.orderReturn?.id || orderReturn?.id || orderReturn?.returnId;
}

export function getReturnStatus({ returnObject, orderReturn }) {
    return orderReturn?.returnStatus || returnObject?.orderReturn?.returnStatus;
}

export function getReturnShipmentCarrier({ orderReturn }) {
    return orderReturn?.shipmentCarrier || orderReturn?.carrier;
}

export function getShipmentSolutionType({ orderReturn }) {
    return orderReturn?.returnShipmentType;
}

export function getOrderItemProduct({ orderItem }) {
    return orderItem?.productVariant?.product;
}

export function getOrderItemProductImage({ orderItem }) {
    return getProductVariantImage(orderItem?.productVariant);
}

export function getOrderItemProductName({ orderItem, productVariant = orderItem?.productVariant }) {
    return productVariant?.product?.title || orderItem?.name;
}

export function getOrderItemProductVariantName({ orderItem, productVariant = orderItem?.productVariant }) {
    return productVariant?.title;
}

export function getOrderItemSku({ orderItem, productVariant = orderItem?.productVariant }) {
    return orderItem?.sku || productVariant?.sku;
}

export function getOrderItemBarCode({ orderItem, productVariant = orderItem?.productVariant }) {
    return orderItem?.barcode || productVariant?.barCode;
}

export function orderReturnHasExchanges(orderReturn) {
    return !!orderReturn?.numberOfExchanges;
}

export function getOrderBrand(order) {
    return order?.merchantBrand;
}

export function getOrderBrandId(order) {
    return getBrandId(getOrderBrand(order));
}

export function getOrderBrandLogo(order) {
    return getBrandLogo(getOrderBrand(order));
}

export function getForeignOrderId(order) {
    return order?.foreignId;
}

export function getForeignOrderNumber(order) {
    return order?.foreignNumber;
}

export function getForeignOrderName(order) {
    return order?.orderForeignName || order?.foreignName;
}

export function getOrderVisualId(order) {
    return getForeignOrderName(order) || getForeignOrderNumber(order) || getForeignOrderId(order) || getOrderId(order);
}

export function getOrderCurrencyCode(order) {
    return order?.currencyCodeCustomer || order?.currencyCode;
}

// Mirrors how TableCellReturnItems derives its count from an order alone, so a row that guards on the
// count and the cell that renders it can't disagree about whether the order has items.
export function getOrderNumberOfItems(order) {
    return order?.totalQuantityBundlesCollapsed || order?.numberOfLineItems;
}
